import {
  TERMINAL_LOCATION_EVENT_REQUEST,
  TERMINAL_LOCATION_EVENT_REQUEST_SUCCESS,
  TERMINAL_LOCATION_EVENT_REQUEST_FAILURE,
  TERMINAL_LOCATION_EVENT_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalLocationEventsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_LOCATION_EVENT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_LOCATION_EVENT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_LOCATION_EVENT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_LOCATION_EVENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalLocationEventsReducer;
